import { Inject, Injectable, Optional } from "@angular/core";
import { LuxonDateAdapter } from "@angular/material-luxon-adapter";
import { MAT_DATE_LOCALE } from "@angular/material/core";


@Injectable()
export class UTCLuxonDateAdapter extends LuxonDateAdapter {

    constructor(@Optional() @Inject(MAT_DATE_LOCALE) matDateLocale: string) {
        super(matDateLocale, { useUtc: false, firstDayOfWeek: 1, defaultOutputCalendar: 'iso8601' })
    }

}